import Vue from 'vue'
import Router from '~/router'
import VueAnalytics from 'vue-analytics'

if (env('VUE_APP_GA_CODE')) {
    Vue.use(VueAnalytics, {
        id: env('VUE_APP_GA_CODE'),
        router: Router,
    })
}
